/**
 * Auth helpers — magic link sign-in per app.pact.constraint.auth.002 (email allowlist).
 * Per app.pact.constraint.responsive.007: works on mobile too.
 */
import { supabase } from './supabase'

export async function signInWithMagicLink(email: string, redirectTo?: string) {
  return supabase.auth.signInWithOtp({
    email,
    options: {
      emailRedirectTo: redirectTo ?? window.location.origin,
    },
  })
}

export async function signOut() {
  return supabase.auth.signOut()
}

export async function getSession() {
  return supabase.auth.getSession()
}

export async function onAuthStateChange(callback: (event: string, session: any) => void) {
  return supabase.auth.onAuthStateChange(callback)
}
